export default {"src":"/_next/static/media/bfk-logo-horiz-fc.9bd885fe.svg","height":350,"width":800,"blurWidth":0,"blurHeight":0};